/*
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default { 

  resetStore() {
    // reset store to empty
    Store.dispatch('reports/setScheduledReports', {
      scheduledReports: [],
    });
  },

  async listScheduled(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['reports/scheduledReports'].length < 1) {
      try {
        const response = await Api(true).get('/report/list_schedule');

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetStore();
            return response.data.message;
          } else {
            Store.dispatch('reports/setScheduledReports', {
              scheduledReports: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetStore();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('report.ts - listScheduled - 46 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  create(params: {
    reportType: number,
    title: string,
    emailAddress: string,
  }) {
    return Api(true).post('/report/create', params);
  },

  update(params: {
    id: number,
    emailAddress: string,
  }) {
    return Api(true).post('/report/update', params);
  },

  resendProofOfDelivery(params: {
    customerId: number,
    loadId: number,
    title: string,
    emailAddress: string,
  }) {
    return Api(true).post('/report/pod', params);
  },

  emailRatesSheet(params: {
    customerId: number,
    emailAddress: string,
  }) {
    return Api(true).post('/report/rate_sheet', params);
  },

  emailAdjustmentRatesSheet(params: {
    customerId: number,
    routeAdjustmentHeaderId: number,
    emailAddress: string,
  }) {
    return Api(true).post('/report/adjustment_rate_sheet', params);
  },
}